module.exports = __webpack_public_path__ + "static/img/IMG_20151224_185632.11549ee0.jpg";